// Get Invoice Items List for Single Job Page
export const GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST =
  "GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST";
export const GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_SUCCESS =
  "GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_SUCCESS";
export const GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_FAILURE =
  "GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_FAILURE";
